import { phxErpDataSyncSeriveBaseUrl } from "../../../../../../services/http";

export const phxErpDataSyncServiceEndpoints = {
    consumer : `${phxErpDataSyncSeriveBaseUrl}/consumer`
}